import { PageRequestModel } from '@/models';
import { GetTaskListRequestFilterModel } from './GetTaskListRequestFilterModel';
import { SortingSettingsTaskModel } from './SortingSettingsTaskModel';

export class GetTaskListByTreeShortRequestModel {
  CurrentUserId!: number;
  GroupId?: number;
  NamespaceId?: string;
  NamespaceIds!: Array<string>;
  QueueTaskIds!: Array<string>;
  ProjectId?: number;
  Filter!: GetTaskListRequestFilterModel;
  SortingSettings!: SortingSettingsTaskModel;
  Page!: PageRequestModel;
  DateStart?: Date;
  DateEnd?: Date;
  IsFilterTimerByPerformerIds: boolean = false;

  constructor(obj?: Partial<GetTaskListByTreeShortRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
